<template>
  <div class="d-flex">
    <div :class="[$style.dateOfMatch]">
      {{ dateOfMatch }},
    </div>
    <div :class="[$style.timeOfMatch]">
      &nbsp;{{ timeOfMatch }}
      <span :class="$style.dayPart">{{ dayPartOfMatch }}</span>
    </div>
  </div>
</template>

<script>
import { format, parse } from 'date-fns'

export default {
  name: 'BaseMatchDate',
  props: {
    date: {
      type: [Date, String],
      required: true,
    },
  },
  data() {
    return {
      matchDate: parse(this.date),
    }
  },
  computed: {
    dateOfMatch() {
      return format(this.matchDate, 'D.M')
    },
    timeOfMatch() {
      return format(this.matchDate, 'H:mm')
    },
    dayPartOfMatch() {
      return format(this.matchDate, 'a')
    },
  },
}
</script>

<style module lang="scss">
  @import "../../assets/scss/variables";
  .dayPart {
    font-size: $font-size-small;
  }
</style>
